export const QUERY_KEYS = {
  currentUser: "currentUser",
  getProjects:"getProjects",
  getProjectDetails:"getProjectDetails",
  organisation:"organisation",
  taskById:"taskById",
  taskMamber:"taskMamber",
  allTask:"allTask",
  myTasks: "myTasks",
  allNotification:"allNotification",
  notificationHistory: "notificationHistory",
  allKanbanColumn:"allKanbanColumn",
  ProjectMember:"getProjectMembers",
  DemoProject:"getDemoProject",
  getLocation:"getLocation",
  paymentStatus:"paymentStatus",
  paymentInvoice:"paymentInvoice",
  paymentsubscription:"subscription",
  paymentInvoicePortal:"paymentInvoicePortal",
  risk:"risk",
  demoRisk:"demoRisk",
  ribbon:"ribbon",
  setting:"setting",
  portfolios:"portfolios",
  allToken:"allToken",
  collaboratorVerificationToken:"collaboratorVerificationToken",
  getAvailabilityByUserID:"getAvailabilityByUserID",
  getProjectsNocal:"getProjectsNocal",
  getAllAvailability:"getAllAvailability",
  getAllAbsentType:"getAllAbsentType",
  dashboardStatusSummary:"dashboardStatusSummary",
  dashboardPortfolioProgress:"dashboardPortfolioProgress",
  dashboardProjectPerformance:"dashboardProjectPerformance",
  portfolioDashboard:"portfolioDashboard",
  timesheet: "timesheet",
  timesheetPeriod: "timesheetPeriod",
  timesheetPending: "timesheetPending",
  timesheetSidebarCounts: "timesheetSidebarCounts",
  timesheetPeriodReview: "timesheetPeriodReview",
  jobTitles: "jobTitles",
  laborCostRates: "laborCostRates",
  contractTypes: "contractTypes",
  teamUnits: "teamUnits",
  projectSummary: "projectSummary",
  projectPerformance: "projectPerformance",
  projectAlerts: "projectAlerts",
  projectHighlights: "projectHighlights",
  workstreams: "workstreams",
  projectTypes: "projectTypes",
  projectPhases: "projectPhases",
  projectPriorities: "projectPriorities",
  projectCategories: "projectCategories",
  projectBaseline: "projectBaseline",
  nonLaborCostTypes: "nonLaborCostTypes",
  nonLaborCosts: "nonLaborCosts",
  laborCosts: "laborCosts",
  userProfile: "userProfile",
  dashboardPortfolioCapacity: "dashboardPortfolioCapacity",
  budgetOverview: "budgetOverview",
  capacityThresholds: "capacityThresholds",
  capacityPlanningOverview: "capacityPlanningOverview",
  budgetPerformance: "budgetPerformance",
  capacityPlanningFilterOptions: "capacityPlanningFilterOptions",
  publicDocCategories: "publicDocCategories",
  publicDocArticles: "publicDocArticles",
  deliverables: "deliverables",
  deliverableDetail: "deliverableDetail",
  deliverableKpis: "deliverableKpis",
  deliverableListValues: "deliverableListValues",
} as const;
